var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDefinitionHd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20120_241602)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 9.6,
    rx: 1.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2 0C0.537258 0 0 0.537258 0 1.2V8.4C0 9.06274 0.537259 9.6 1.2 9.6H10.8C11.4627 9.6 12 9.06274 12 8.4V1.2C12 0.537258 11.4627 0 10.8 0H1.2ZM5.57517 7.2V2.1456H4.34397V4.1256H2.42877V2.1456H1.19757V7.2H2.42877V5.1192H4.34397V7.2H5.57517ZM9.75438 2.4624C9.35598 2.2512 8.89038 2.1456 8.35758 2.1456H6.46398V7.2H8.35758C8.88558 7.2 9.34878 7.0944 9.74718 6.8832C10.1504 6.672 10.46 6.3744 10.676 5.9904C10.8968 5.6064 11.0072 5.1672 11.0072 4.6728C11.0072 4.1736 10.8968 3.7344 10.676 3.3552C10.46 2.9712 10.1528 2.6736 9.75438 2.4624ZM9.36558 5.7528C9.10638 6.0072 8.74398 6.1344 8.27838 6.1344H7.69518V3.1968H8.27838C8.74398 3.1968 9.10638 3.3264 9.36558 3.5856C9.62478 3.8448 9.75438 4.2072 9.75438 4.6728C9.75438 5.1384 9.62478 5.4984 9.36558 5.7528Z",
    fill: "#FF443A",
    className: "red"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20120_241602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 9.6,
    rx: 1.2,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefinitionHd);
export default __webpack_public_path__ + "static/media/icon-definition-hd.e9161cb54142880a3ec22be8c1f2c3e5.svg";
export { ForwardRef as ReactComponent };